import { types } from 'mobx-state-tree';
import { model, Model } from 'mst-collection';

import { useRoot } from '../useRoot';
import { ContactUsModel } from './ContactUsModel';
import { ReportModel } from './ReportModel';

export class Support extends Model({
  contactUs: types.optional(ContactUsModel, {}),
  report: types.optional(ReportModel, {}),
}) {}

export const SupportModel = model(Support);

export function useSupportModel() {
  const root = useRoot();

  return root.support;
}
